import { render, staticRenderFns } from "./Broadcast.vue?vue&type=template&id=c92d36b8&scoped=true&"
import script from "./Broadcast.vue?vue&type=script&lang=js&"
export * from "./Broadcast.vue?vue&type=script&lang=js&"
import style0 from "./Broadcast.vue?vue&type=style&index=0&id=c92d36b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92d36b8",
  null
  
)

export default component.exports